// ─────────────────────────────────────────────────────────────
//  About.jsx  —  About Us page · TheVisaCo
//  Sections:
//    1. Hero
//    2. Photo Mosaic Strip
//    3. Our Story (split)
//    4. Timeline (conveyor belt auto-scroll)
//    5. Our Mission (split reversed)
//    6. Our Values (photo cards grid)
//    7. Popular Destinations (auto-scroll marquee)
//    8. Platform Modules (5-per-row photo cards)
//    9. Team — CEOs + Department Leads (redesigned)
// ─────────────────────────────────────────────────────────────

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./About.css";
import {
  BRAND,
  STATS,
  FEATURES,
  VALUES,
  MISSION,
  HERO_TITLE,
  FEATURES_SUBTITLE,
  STORY_PARAGRAPHS,
  TIMELINE,
  TEAM_SUBTITLE,
  STORY_IMAGE,
  POPULAR_COUNTRIES,
  STORY_HEADING,
  STORY_BADGE_YEAR,
  STORY_BADGE_TEXT,
  MISSION_HEADING,
  VALUES_HEADING,
  VALUES_SUBTITLE,
  TIMELINE_HEADING,
  TIMELINE_SUBTITLE,
  FEATURES_HEADING,
  TEAM_HEADING,
  COUNTRIES_HEADING,
  COUNTRIES_SUBTITLE,
  PHOTO_STRIP,
  ALL_TEAM,
} from "./AboutData.js";
import { getVisaIdForDestination } from "../../Home/homeData/homeConstants.js";

// ── Team Tabs ────────────────────────────────────────────────
function TeamTabs() {
  const [active, setActive] = useState(0);
  const [canScroll, setCanScroll] = useState(false);
  const [showArrow, setShowArrow] = useState(false);
  const p = ALL_TEAM[active];
  const scrollRef = useRef(null);
  const tabBarRef = useRef(null);
  const hideTimer = useRef(null);
  const scrollTab = (dir) => {
    if (tabBarRef.current) {
      tabBarRef.current.scrollBy({ left: dir * 200, behavior: "smooth" });
    }
  };
  useEffect(() => {
    const el = scrollRef.current;
    if (el) {
      setCanScroll(el.scrollHeight > el.clientHeight);
      const onScroll = () => {
        const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 2;
        if (atBottom) {
          setShowArrow(false);
          clearTimeout(hideTimer.current);
        } else {
          setShowArrow(true);
          clearTimeout(hideTimer.current);
          hideTimer.current = setTimeout(() => setShowArrow(false), 1500);
        }
      };
      el.addEventListener("scroll", onScroll);
      return () => {
        el.removeEventListener("scroll", onScroll);
        clearTimeout(hideTimer.current);
      };
    }
  }, [active]);
  const scrollToBottom = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ top: scrollRef.current.scrollHeight, behavior: "smooth" });
    }
  };

  return (
    <div className="ab__team-tabs">
      <div className="ab__team-tab-bar-wrap">
        <button className="ab__tab-arrow ab__tab-arrow--left" onClick={() => scrollTab(-1)} aria-label="Scroll left"><IcoChevronLeft /></button>
        <div className="ab__team-tab-bar" ref={tabBarRef}>
          {ALL_TEAM.map((person, i) => (
            <button
              key={person.id}
              className={`ab__team-tab ${i === active ? "ab__team-tab--active" : ""}`}
              onClick={() => setActive(i)}
            >
              {person.role}
            </button>
          ))}
        </div>
        <button className="ab__tab-arrow ab__tab-arrow--right" onClick={() => scrollTab(1)} aria-label="Scroll right"><IcoChevronRight /></button>
      </div>

      <div className="ab__team-tab-content" key={active}>
        <div className="ab__team-tab-card">
          <div className="ab__team-tab-img">
            <img src={p.image} alt={p.name} loading="lazy" />
          </div>
          <div className="ab__team-tab-info">
            <div className="ab__team-tab-top">
              <h3 className="ab__team-tab-name">{p.name}</h3>
              <span className="ab__team-tab-role">{p.role}</span>
              <p className="ab__team-tab-bio">{p.bio}</p>
            </div>
            <div className="ab__team-tab-scroll">
            <div className="ab__team-tab-scroll-inner" ref={scrollRef}>
                <p className="ab__team-tab-bio"
                   onMouseEnter={() => { if (canScroll) setShowArrow(true); clearTimeout(hideTimer.current); }}
                   onMouseLeave={() => { hideTimer.current = setTimeout(() => setShowArrow(false), 1500); }}>
                  TheVisaCo was founded on the belief that every Indian traveller deserves access to accurate, up-to-date visa information without having to navigate confusing government websites, outdated PDFs, or conflicting advice from multiple sources. What started as a small project in a coffee shop in Karol Bagh has grown into a comprehensive platform that now serves over 80,000 monthly travellers across 195 countries. Our team of visa experts, engineers, and product designers work tirelessly to ensure that every piece of data on our platform is verified against official government sources, every appointment slot is checked in real time, and every user gets the support they need to complete their application with confidence. We have built partnerships with embassies, consulates, and visa processing centres around the world to bring you the most reliable information possible. Our platform covers everything from Schengen visa appointments and US visa interview preparation to document checklists, fee histories, and direct consultation with certified visa advisors. We believe that the visa application process should not require a dedicated project manager, yet for most Indian travellers that is exactly what it has become. TheVisaCo exists to fix that by bringing all the tools, information, and support you need into one beautifully designed platform that is accessible from any device, anywhere in India. Our mission is to eliminate visa anxiety for every Indian traveller by delivering accurate information, smart tooling, and expert consultation all in one place. We have built a platform that combines real-time appointment tracking, AI-powered document review, comprehensive country guides, and direct access to certified visa advisors. Every feature is designed with the first-time traveller in mind, ensuring that clarity and simplicity are at the core of everything we build. We monitor changes in visa policies across 195 countries daily, update our databases in real t... (line truncated to 2000 chars)
                </p>
                {(canScroll && showArrow) && (
                  <div className="ab__scroll-arrow-wrap">
                    <button className="ab__team-scroll-arrow" onClick={scrollToBottom} aria-label="Scroll to bottom"><IcoChevronDown /></button>
                  </div>
                )}
            </div>
            </div>
            <div className="ab__team-tab-bottom">
              {p.funFact && (
                <div className="ab__team-tab-fact">
                  <span className="ab__team-tab-fact-label">Fun fact</span>
                  {p.funFact}
                </div>
              )}
              {p.linkedin && (
                <a href={p.linkedin} className="ab__team-tab-linkedin" target="_blank" rel="noopener noreferrer">
                  <IcoLinkedIn /> Connect on LinkedIn <IcoArrow />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Icons ─────────────────────────────────────────────────────
const IcoLinkedIn = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);
const IcoArrow = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="7" y1="17" x2="17" y2="7"/><polyline points="7 7 17 7 17 17"/>
  </svg>
);
const IcoArrowRight = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
  </svg>
);
const IcoChevronDown = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);
const IcoChevronLeft = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6"/>
  </svg>
);
const IcoChevronRight = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6"/>
  </svg>
);

// ── Fade-up hook ──────────────────────────────────────────────
function useFadeUp(threshold = 0.1) {
  const ref = useRef(null);
  const [vis, setVis] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVis(true); obs.disconnect(); } },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, vis];
}

function FadeUp({ children, delay = 0, style = {} }) {
  const [ref, vis] = useFadeUp();
  return (
    <div
      ref={ref}
      style={{
        opacity: vis ? 1 : 0,
        transform: vis ? "translateY(0)" : "translateY(32px)",
        transition: `opacity 0.68s cubic-bezier(0.4,0,0.2,1) ${delay}ms, transform 0.68s cubic-bezier(0.4,0,0.2,1) ${delay}ms`,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

// ── Animated counter ─────────────────────────────────────────
function useCounter(target, duration = 1600, start = false) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!start) return;
    const num = parseFloat(target.replace(/[^0-9.]/g, ""));
    if (!num) return;
    let raf;
    const startTime = performance.now();
    function tick(now) {
      const prog = Math.min((now - startTime) / duration, 1);
      const ease = 1 - Math.pow(1 - prog, 3);
      setVal(Math.floor(ease * num));
      if (prog < 1) raf = requestAnimationFrame(tick);
      else setVal(num);
    }
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [start, target, duration]);
  return val;
}

function StatItem({ stat }) {
  const [ref, vis] = useFadeUp(0.3);
  const num = useCounter(stat.value, 1800, vis);
  const suffix = stat.value.replace(/[0-9.]/g, "");
  return (
    <div ref={ref} className="ab__hero-stat">
      <span className="ab__hero-stat-value">
        {vis ? `${num}${suffix}` : "0"}
      </span>
      <span className="ab__hero-stat-label">{stat.label}</span>
    </div>
  );
}

// ── Timeline Horizontal Scroll ────────────────────────────────
function TimelineSection() {
  const doubled = [...TIMELINE, ...TIMELINE];

  return (
    <section className="ab__section">
      <div className="ab__container">
        <FadeUp>
          {/* <div className="ab__eyebrow">{TIMELINE_HEADING}</div> */}
          <h2 className="ab__section-title">{TIMELINE_HEADING}</h2>
          <p className="ab__section-sub">{TIMELINE_SUBTITLE}</p>
        </FadeUp>
      </div>

      <div className="ab__timeline-outer">
        <div className="ab__container--wide">
          <FadeUp delay={100}>
            <div className="ab__timeline-h">
              <div className="ab__timeline-h-inner ab__timeline-h-inner--anim">
                {doubled.map((item, i) => (
                  <div key={`tl-${i}`} className="ab__tl-card">
                    <div className="ab__tl-dot-wrap">
                      <div className="ab__tl-badge">
                        <span className="ab__tl-year">{item.year}</span>
                        <span className="ab__tl-month">{item.month}</span>
                      </div>
                      <div className="ab__tl-dot" />
                    </div>
                    <div className="ab__tl-img">
                      <img src={item.image} alt={item.title} loading="lazy" />
                    </div>
                    <div className="ab__tl-title">{item.title}</div>
                    <p className="ab__tl-body">{item.body}</p>
                  </div>
                ))}
              </div>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}

// ── Destinations Marquee ──────────────────────────────────────
function DestinationsMarquee() {
  const navigate = useNavigate();
  const [rows, setRows] = useState(3);
  const TRIPLED = [...POPULAR_COUNTRIES, ...POPULAR_COUNTRIES, ...POPULAR_COUNTRIES];

  const handleDestClick = (name) => {
    const id = getVisaIdForDestination(name);
    navigate(`/visa/${id}`);
  };

  useEffect(() => {
    const update = () => setRows(window.innerWidth <= 900 ? 2 : 3);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return (
    <section className="ab__section ab__section--tinted ab__section--dest-dark">
      <div className="ab__container">
        <FadeUp>
          {/* <div className="ab__eyebrow">{COUNTRIES_HEADING}</div> */}
          <h2 className="ab__section-title">{COUNTRIES_HEADING}</h2>
          <p className="ab__section-sub">{COUNTRIES_SUBTITLE}</p>
        </FadeUp>
      </div>

      <div className="ab__dest-rows">
        {Array.from({ length: rows }, (_, i) => (
          <div key={i} className={`ab__dest-row ${i % 2 === 0 ? "ab__dest-row--ltr" : "ab__dest-row--rtl"}`}>
            <div className="ab__dest-row-track">
              {TRIPLED.map((c, j) => (
                <div key={`dest-${i}-${j}`} className="ab__dest-card" onClick={() => handleDestClick(c.name)} style={{ cursor: "pointer" }}>
                  <img src={c.image} alt={c.name} loading="lazy" />
                  <div className="ab__dest-card-overlay" aria-hidden="true" />
                  <div className="ab__dest-card-body">
                    <span className="ab__dest-name">{c.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

// ─────────────────────────────────────────────────────────────
export default function About() {
  const [activeFeature, setActiveFeature] = useState(null);
  const [showAllFeatures, setShowAllFeatures] = useState(false);
  const [initialCount, setInitialCount] = useState(10);
  const navigate = useNavigate();

  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w <= 560)       setInitialCount(2);
      else if (w <= 768)  setInitialCount(4);
      else if (w <= 900)  setInitialCount(6);
      else if (w <= 1280) setInitialCount(8);
      else                setInitialCount(10);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const visibleFeatures = FEATURES.slice(0, showAllFeatures ? FEATURES.length : initialCount);

  return (
    <div className="ab">

      {/* ══════════════════════════════════════════════════
          1. HERO
      ══════════════════════════════════════════════════ */}
      <section className="ab__hero">
        <div className="ab__hero-inner">
          {/* <FadeUp>
            <div className="ab__hero-badge">
              <span className="ab__hero-badge-dot" aria-hidden="true" />
              {BRAND.tagline}
            </div>
          </FadeUp> */}
          <FadeUp delay={80}>
            <h1 className="ab__display-title">{HERO_TITLE}</h1>
          </FadeUp>
          {/* <FadeUp delay={160}>
            <p className="ab__hero-sub">{BRAND.description}</p>
          </FadeUp> */}
          <FadeUp delay={240}>
            <div className="ab__hero-stats">
              {STATS.map((s) => <StatItem key={s.label} stat={s} />)}
            </div>
          </FadeUp>
          {/* <FadeUp delay={320}>
            <div className="ab__hero-scroll-cue" aria-hidden="true" />
          </FadeUp> */}
        </div>
      </section>

      {/* ══════════════════════════════════════════════════
          2. PHOTO MOSAIC STRIP
      ══════════════════════════════════════════════════ */}
      <div className="ab__photo-strip">
        {PHOTO_STRIP.map((img, i) => (
          <div key={i} className="ab__photo-strip-item">
            <img src={img.src} alt={img.alt} loading="lazy" />
            <div className="ab__photo-strip-overlay" aria-hidden="true" />
          </div>
        ))}
      </div>

      {/* ══════════════════════════════════════════════════
          3. OUR STORY
      ══════════════════════════════════════════════════ */}
      <section className="ab__section">
        <div className="ab__container">
          <div className="ab__split">
            <FadeUp>
              <div className="ab__split-text">
                {/* <div className="ab__eyebrow">{STORY_HEADING}</div> */}
                <h2 className="ab__section-title">{STORY_HEADING}</h2>
                {STORY_PARAGRAPHS.map((p, i) => <p key={i}>{p}</p>)}
              </div>
            </FadeUp>
            <FadeUp delay={140}>
              <div className="ab__split-img-wrap">
                <img src={STORY_IMAGE} alt="Traveller with passport" loading="lazy" />
                <div className="ab__split-img-overlay" aria-hidden="true" />
                <div className="ab__split-img-badge">
                  <span>{STORY_BADGE_YEAR}</span>
                  {STORY_BADGE_TEXT}
                </div>
              </div>
            </FadeUp>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════
          4. TIMELINE — conveyor belt auto-scroll
      ══════════════════════════════════════════════════ */}
      <TimelineSection />

      {/* ══════════════════════════════════════════════════
          5. OUR MISSION
      ══════════════════════════════════════════════════ */}
      <section className="ab__section ab__section--tinted ab__section--mission">
        <div className="ab__container">
          <FadeUp>
            {/* <div className="ab__eyebrow">{MISSION_HEADING}</div> */}
            <h2 className="ab__section-title">{MISSION_HEADING}</h2>
          </FadeUp>
          <FadeUp delay={100}>
            <div className="ab__mission-text">
              <blockquote className="ab__blockquote">
                "{MISSION}"
              </blockquote>
            </div>
          </FadeUp>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════
          6. OUR VALUES
      ══════════════════════════════════════════════════ */}
      <section className="ab__section">
        <div className="ab__container">
          <FadeUp>
            {/* <div className="ab__eyebrow">{VALUES_HEADING}</div> */}
            <h2 className="ab__section-title">{VALUES_HEADING}</h2>
            <p className="ab__section-sub">{VALUES_SUBTITLE}</p>
          </FadeUp>
          <div className="ab__values-grid">
            {VALUES.map((v, i) => (
              <FadeUp key={v.id} delay={i * 80}>
                <div className="ab__value-card">
                  <div className="ab__value-card-img">
                    <img src={v.image} alt={v.title} loading="lazy" />
                    <div className="ab__value-card-img-overlay" aria-hidden="true" />
                    {/* <div className="ab__value-card-icon-wrap" aria-hidden="true">{v.icon}</div> */}
                  </div>
                  <div className="ab__value-card-body">
                    <div className="ab__value-card-title">{v.title}</div>
                    {/* <p className="ab__value-card-desc">{v.description}</p> */}
                  </div>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════
          7. POPULAR DESTINATIONS — auto-scroll marquee
      ══════════════════════════════════════════════════ */}
      <DestinationsMarquee />

      {/* ══════════════════════════════════════════════════
          8. PLATFORM MODULES
      ══════════════════════════════════════════════════ */}
      <section className="ab__section">
        <div className="ab__container">
          <FadeUp>
            {/* <div className="ab__eyebrow">{FEATURES_HEADING}</div> */}
            <h2 className="ab__section-title">{FEATURES_HEADING}</h2>
            <p className="ab__section-sub">{FEATURES_SUBTITLE}</p>
          </FadeUp>
          <div className="ab__features-grid">
            {visibleFeatures.map((f, i) => (
              <FadeUp key={f.id} delay={i * 35}>
                <div
                  className={`ab__feature-card${activeFeature === f.id ? " ab__feature-card--active" : ""}`}
                  onClick={() => f.route ? navigate(f.route) : setActiveFeature(activeFeature === f.id ? null : f.id)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                      f.route ? navigate(f.route) : setActiveFeature(activeFeature === f.id ? null : f.id);
                  }}
                  aria-label={f.title}
                >
                  <div className="ab__feature-card-img" style={{ background: f.color }}>
                    <img src={f.image} alt={f.title} loading="lazy" />
                    <div className="ab__feature-card-img-overlay" aria-hidden="true" />
                    {/* <span className="ab__feature-card-num-badge">
                      {String(i + 1).padStart(2, "0")}
                    </span> */}
                  </div>
                  <div className="ab__feature-card-body">
                    <h3 className="ab__feature-card-title">{f.title}</h3>
                    <p className="ab__feature-card-desc">{f.description}</p>
                    {f.tags && (
                      <div className="ab__feature-card-tags">
                        {f.tags.map((t) => <span key={t} className="ab__tag">{t}</span>)}
                      </div>
                    )}
                    <span className="ab__feature-card-arrow">
                      Explore module <IcoArrowRight />
                    </span>
                  </div>
                </div>
              </FadeUp>
            ))}
          </div>
          {FEATURES.length > initialCount && (
            <div className="ab__toggle-wrap">
              <button className="ab__toggle-btn" onClick={() => setShowAllFeatures(!showAllFeatures)}>
                {showAllFeatures ? "View Less" : `View All ${FEATURES.length} Modules`}
              </button>
            </div>
          )}
        </div>
      </section>

      {/* ══════════════════════════════════════════════════
           9. TEAM — tabbed role cards
      ══════════════════════════════════════════════════ */}
      <section className="ab__section ab__section--team">
        <div className="ab__container">

          <FadeUp>
            {/* <div className="ab__eyebrow">{TEAM_HEADING}</div> */}
            <h2 className="ab__section-title">{TEAM_HEADING}</h2>
            <p className="ab__section-sub">{TEAM_SUBTITLE}</p>
          </FadeUp>

          <TeamTabs />

        </div>
      </section>

    </div>
  );
}